import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import '../css/footer.css';
import logo from "../images/chainpad/logos.png";
import { FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";
import { TbBallBasketball } from "react-icons/tb";
import { getsettinghook } from '../hooks/usebackend';
import { FiSend } from "react-icons/fi";
import { mainurl } from '../config/env';

class Footer extends Component 
{ 
    constructor(props) {
        super(props);
        this.state = {
          settings: []   // initial empty
        };
      }

      componentDidMount() {
        // if you have a function that gives data
        // const data = getsettinghook();  // must be a plain function, not a hook
        // this.setState({ settings: data.data });
        
        this.getsetting()
      }

      getsetting = async()=>{
       
        let setting = await getsettinghook();
        console.log("setting" , setting?.data?.data);
        if(setting?.data?.success == true){
        this.setState({"settings" : setting?.data?.data});
        }
    
      }
  
   
    render() {
        const { settings } = this.state;
        console.log("links_links",settings,this?.state?.settings[0]?.settingvalue);
		return (
           <div>
               <div className="footer">
               <div className="footer_bg_purple">
               <div className='container'>
                <div className='footer_all'>
                    
                    <div>
                        <img src={logo} />
                        {/* <p className='copytxt mb-1 mt-4'>Copyright © 2025 Lumina</p>
                        <p className='copytxt'>All rights reserved</p>
                        <ul className='social_footer pt-2'>
                            <li><a href={this?.state?.settings[0]?.settingvalue} target='_blank'><FaInstagram/></a></li>
                            <li><a href={this?.state?.settings[1]?.settingvalue} target='_blank'><TbBallBasketball/></a></li>
                            <li><a href={this?.state?.settings[2]?.settingvalue} target='_blank'><FaTwitter/></a></li>
                            <li><a href={this?.state?.settings[3]?.settingvalue} target='_blank'><FaYoutube/></a></li>

                        </ul> */}
                    </div>

                    <div className='footersec'>
                        <ul className='d-block d-sm-flex gap_4'>
                           <li><a href="#" rel="noopener noreferrer">Docs</a></li> 
                                                      <li><a href="#" rel="noopener noreferrer">Support</a></li> 

                           <li><a href="#" rel="noopener noreferrer">Terms & Conditions</a></li> 

                           <li><a href="#" rel="noopener noreferrer">Privacy Policy</a></li> 

                        </ul>
                        {/* <ul>
                            <span className="fontThick">Company</span>
                             <li className='mt-4'><a href={`${mainurl}/swap`} rel="noopener noreferrer">Trade</a></li>
                             <li><a href={`${mainurl}/liquiditypools`} rel="noopener noreferrer">Earn</a></li>
                             <li><a href="/launchpadlist">Launchpad</a></li>
                             <li><a href={`${mainurl}/voting`}  rel="noopener noreferrer">Voting</a></li>
                        </ul> */}
                       
                    </div>
                </div>

                  {/* <div>
                            <p className="fontThick">Stay up to date</p>
                            <div className='emailfooter'>
                                <input type="email" placeholder="Your email address" className=''/>
                                <span className='footicon'><FiSend/></span>
                            </div>
                        </div> */}
                  
               {/* <div className="footer_sec_2">
               <div className="container conatiner_custom">
                  
                   <ul className="footer_ul footer_ul_hor">
                                   
                                   <li><a href="https://twitter.com/tatswap" target="_blank" className="mr-3"><span className="fa fa-twitter"></span></a></li>
                                   <li><a href="https://telegram.me/+VOXtFEJ7-wxlNmU0" target="_blank" className="mr-3"> <span className=" fa fa-paper-plane"></span> </a></li>
                                   <li><a href="mailto:mailto:support@tatwap.com" target="_blank" className="mr-0"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>

                                    
                               </ul>
                               <p className="mb-0 text-center footer_text mb-0 mt-3">© Copyrights 2021, Wealth Universe all rights reserve. Terms | Privacy</p>
                   </div>
               </div> */}
               </div>
          </div>
           </div>
           </div>
        );
    }
}

export default Footer